//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";

export default {
  name: "NIH",
  data() {
    return {
      defaultJson: {
        "4-FacialPalsy_0pt_short": "正常对称运动",
        "4-FacialPalsy_2pt_short": "部分面瘫",
        Dysarthria: "构音障碍",
        "4-FacialPalsy_2pt_long": "部分面瘫（颜面下半部完全或几乎完全瘫痪）",
        "2-BestGaze_1pt_short": "部分凝视麻痹",
        "3-VisualFields_3pt_long": "双侧偏盲（包括皮质盲）",
        "7-LimbAtaxia_2pt_long": "表现在两个肢体",
        "6-MotorLeg_2pt_long":
          "部分对抗重力；肢体在 5 秒内下落到床上，但可以部分对抗重力",
        "10-Dysarthria_0pt_long": "正常",
        LocQuestionsHint:
          "患者被要求回答当前月份及其年龄。答案必须完全正确 - 不存在部分正确或接近的回答。失语和昏迷者不能理解问题记 2 分。因气管插管、气管创伤、严重构音障碍、语言障碍或其他任何非失语所致不能说话者记 1 分。仅对初次回答评分，且检查者不得给予任何肢体或非肢体的“提示”。",
        "9-BestLanguage_3pt_long": "缄默，完全性失语；无言语或听力理解能力",
        LimbAtaxiaHint:
          "该检查的目的是发现一侧小脑病变的证据。检查时睁眼。若有视力障碍，应确保检查在无缺损的视野中进行。指鼻试验和跟膝胫试验应双侧对比进行，只有当与无力明显不呈比例时才记分。若患者无法理解或肢体瘫痪则不记分。只有在截肢或关节融合的情况下，检查者才应记录“无法测试（UN）”，并写明原因。盲人用伸展的上肢摸鼻。",
        "11-Extinction_1pt_long":
          "视、触、听、空间觉或对人的忽视；或对某一种感觉的双侧刺激忽视",
        "LOC Questions": "意识水平提问",
        "5-MotorArm_0pt_short": "无下移",
        "10-Dysarthria_2pt_short": "重度构音障碍",
        "8-Sensory_2pt_long": "重度-完全感觉缺失；面部、上肢以及下肢无触觉",
        "1a-LOC_3pt_long":
          "仅有反射性活动或自发性反应或完全无反应、软瘫、以及无反射",
        "1a-LOC_3pt_short": "昏迷",
        "5-MotorArm_1pt_long":
          "下移；肢体处于抬高 90 度（或 45 度）位置，但 10 秒内下落；不撞击床或其他支持物",
        "5-MotorArm_4pt_long": "无运动",
        "8-Sensory_2pt_short": "重度-完全感觉缺失",
        "11-Extinction_2pt_short": "对一种以上感觉",
        "9-BestLanguage_1pt_short": "轻-中度失语",
        "1a-LOC_0pt_long": "清醒；反应灵敏",
        "8-Sensory_0pt_long": "正常；无感觉缺失",
        LocCommandsHint:
          "患者被要求睁眼和闭眼以及非瘫痪侧握拳和松开。如果手部无法活动则用另一种单步指令替代。对由于虚弱所致的有明确努力但未完成的也应给分。若对指令无反应，可用动作示意，然后记录评分。对创伤、截肢或其他生理缺陷者，应予适当的单步指令。仅对最初反应评分。",
        "6-MotorLeg_1pt_short": "下移",
        Sensory: "感觉",
        "7-LimbAtaxia_1pt_long": "表现在一个肢体",
        SensoryHint:
          "检查对针刺的感觉和表情，或意识障碍及失语患者对有害刺激的躲避。只对与脑卒中有关的感觉缺失记分为异常。检查者应测试身体多处区域（上肢（不包括手）、下肢、躯干、面部）以精确检查偏身感觉障碍。只有当明确表现为严重或完全的感觉缺失时记 2 分。因此昏睡或失语者记 1 或 0 分。脑干卒中双侧感觉缺失者记 2 分。无反应或四肢瘫痪者记 2 分。昏迷患者（检查项目 1a = 3）自动记 2 分。",
        "8-Sensory_1pt_long":
          "轻-中度感觉缺失；患侧感觉针刺不尖锐或迟钝；或针刺感缺失但有触觉",
        "10-Dysarthria_1pt_long":
          "轻-中度构音障碍；轻则个别字词发音不清，重则虽有困难但能被理解",
        "2-BestGaze_1pt_long":
          "部分凝视麻痹；单眼或双眼凝视异常，但无强迫凝视或完全凝视麻痹",
        "11-Extinction_2pt_long":
          "严重的偏侧忽视或一种以上的偏侧忽视；不认识自己的手；只能对一侧空间定位",
        "4-FacialPalsy_3pt_long":
          "完全面瘫（单侧或双侧瘫痪，上下面部缺乏运动）",
        "9-BestLanguage_2pt_short": "严重失语",
        "5-MotorArm_2pt_short": "部分对抗重力",
        "1a-LOC_0pt_short": "清醒",
        "LOC Commands": "意识水平指令",
        "4-FacialPalsy_3pt_short": "完全面瘫",
        "1c-LOCcommands_0pt_long": "两项均正确",
        LanguageHint:
          "通过先前的检查项目可以获得大量有关理解能力的信息。在这个测试中，患者被要求描述附图里发生的事件，命名表单上的物品以及朗读列表上的句子。理解能力应该综合本测试及先前的测试结果进行判断。若视觉缺损干扰测试，可让患者识别放在手上的物品，重复和发音。气管插管患者应手写回答。昏迷患者（检查项目 1a = 3）记 3 分。必须为神志不清或不合作的患者确定一个分数，但 3 分仅给不说话且不执行任何指令的患者。",
        "Extinction and Inattention": "忽视",
        "7-LimbAtaxia_0pt_long": "无",
        "9-BestLanguage_3pt_short": "缄默，完全性失语",
        "5-MotorArm_0pt_long": "无下移；肢体保持抬高 90 度（或 45 度）达 10 秒",
        MotorLegHint:
          "肢体置于合适的位置：下肢上抬 30 度（永远取仰卧位进行）。若下肢在 5 秒内下落则记为下移。对失语患者用语言或动作鼓励，不使用伤害性刺激。轮流依次检查每个肢体，从非瘫痪侧开始。只有在截肢或髋关节融合的情况下，检查者应记录“无法测试（UN）”，并写明原因。",
        "6-MotorLeg_1pt_long": "下移；肢体在 5 秒内下落但不撞击床",
        "6-MotorLeg_4pt_long": "无运动",
        "6-MotorLeg_3pt_short": "无法对抗重力",
        "9-BestLanguage_0pt_long": "无失语；正常",
        "1c-LOCcommands_1pt_long": "一项正确",
        "Motor Arm (left)": "上肢运动（左侧）",
        ExtinctionHint:
          "在先前的检查过程中可能已获得了充足的信息用于判断患者忽视的情况。若患者有严重视觉缺失影响双侧视觉的同时检查，且皮肤刺激正常，则记分正常。若失语，但确实表现为对双侧的注意，则记分正常。视空间忽视或疾病失认也可认为是异常的证据。由于只有当表现出异常情况才记分，所以这项测试永远都可以进行。",
        "Motor Leg (left)": "下肢运动（左侧）",
        "4-FacialPalsy_0pt_long": "正常对称运动",
        "4-FacialPalsy_1pt_short": "轻微面瘫",
        "1a-LOC_2pt_long":
          "昏睡或反应迟钝；需反复刺激、强烈或疼痛刺激才有非刻板的反应",
        "Tap the text labels for instructions": "轻点文字查看说明",
        "2-BestGaze_0pt_long": "正常",
        "Best Language": "语言",
        "3-VisualFields_0pt_long": "无视野缺损",
        "5-MotorArm_3pt_long": "无法对抗重力；肢体下落",
        "1a-LOC_2pt_short": "昏睡",
        "10-Dysarthria_2pt_long":
          "重度构音障碍；患者言语不清，不能被理解，但无失语或与失语不成比例，或失音",
        "6-MotorLeg_0pt_short": "无下移",
        LevelOfConsciousnessHint:
          "即使不能全面评价，如气管插管、语言障碍、气管创伤及绷带包扎等，检查者也必须选择 1 个反应。只在患者对有害刺激无反应时（不是反射）才能记 3 分。",
        "Level of Consciousness": "意识水平",
        "Limb Ataxia": "肢体共济失调",
        "Motor Arm (right)": "上肢运动（右侧）",
        "10-Dysarthria_1pt_short": "轻-中度构音障碍",
        "2-BestGaze_2pt_short": "强迫凝视",
        "9-BestLanguage_1pt_long":
          "轻-中度失语；流利程度和理解能力明显下降，但意见表述或表达形式无明显受限。然而，言语和 / 或理解能力的下降可以使得对于指定材料的对话变得困难，甚至难以进行。但是检查者仍可以从患者的反应中判断他想表达的内容。",
        "1c-LOCcommands_2pt_long": "两项均不正确",
        "6-MotorLeg_0pt_long": "无下移；肢体保持抬高 30 度达 5 秒",
        DysarthriaHint:
          "如果患者看起来很正常，则应适当嘱其朗读或重复表上的单词。若有严重的失语，评估自发语言时发音的清晰度。只有当因气管插管或其他物理障碍不能讲话时，检查者应记录“无法测试（UN）”，同时注明原因。不要告诉患者为什么做测试。",
        "11-Extinction_1pt_short": "对一种感觉",
        FacialPalsyHint:
          "要求（或用手势鼓励）患者露出牙齿，上抬眉弓以及闭眼。对于反应差或无法理解的患者，根据有害刺激后面部反应的对称性来记分。若为脸部外伤 / 绷带包扎，经口气管插管，胶带或其他遮挡面部的物理屏障者，应尽量移除，暴露面部。",
        "Facial Palsy": "面瘫",
        "3-VisualFields_3pt_short": "双侧偏盲",
        "1b-LOCquestions_0pt_long": "两项均正确",
        "Since this is a comatose patient you must choose 'Mute, global aphasia' here.":
          "由于该患者处于昏迷状态，在此必须选择“缄默，完全性失语”。",
        "5-MotorArm_1pt_short": "下移",
        "3-VisualFields_1pt_long": "部分偏盲",
        "Visual Fields": "视野",
        "11-Extinction_0pt_long": "正常",
        "5-MotorArm_2pt_long":
          "部分对抗重力；肢体无法达到或维持抬高 90 度（或 45 度），下落到床上，但可以部分对抗重力",
        "6-MotorLeg_3pt_long": "无法对抗重力；肢体立即下落到床上",
        "3-VisualFields_2pt_long": "完全偏盲",
        "1b-LOCquestions_1pt_long": "一项正确",
        "4-FacialPalsy_1pt_long": "轻微面瘫（微笑时鼻唇沟变浅、不对称）",
        "6-MotorLeg_2pt_short": "部分对抗重力",
        "Motor Leg (right)": "下肢运动（右侧）",
        "1a-LOC_1pt_long": "嗜睡；轻微刺激能唤醒，可回答问题，执行指令",
        "9-BestLanguage_2pt_long":
          "严重失语；所有交流都是通过破碎的语言表达；听者必须大量依靠推理、询问以及猜测。能够交换的信息很有限；听者感到交流困难。检查者无法从患者的反应中判断他想表达的内容。",
        MotorArmHint:
          "肢体置于合适的位置：坐位时上肢外展至 90 度（手掌向下），或仰卧位时上抬 45 度。若上肢在 10 秒内下落则记为下移。对失语患者用语言或动作鼓励，不使用伤害性刺激。轮流依次检查每个肢体，从非瘫痪侧开始。只有在截肢或肩关节融合的情况下，检查者应记录“无法测试（UN）”，并写明原因。",
        "2-BestGaze_2pt_long": "强迫凝视，或完全凝视麻痹，不能被头眼反射克服",
        "1b-LOCquestions_2pt_long": "两项均不正确",
        BestGazeHint:
          "只测试水平眼球运动。对随意或反射性眼球运动记分。若眼球偏斜能被随意或反射性活动纠正，记 1 分。若为孤立的周围神经麻痹（第 III、IV、VI 对脑神经）记 1 分。对失语患者凝视是可以测试的。对眼球创伤、绷带包扎、盲人或有其他视力、视野障碍者，应由检查者选择一种反射性运动来测试。建立眼球的联系，然后从一侧向另一侧运动，偶尔能发现部分性凝视麻痹。",
        "Best Gaze": "凝视",
        "8-Sensory_1pt_short": "轻-中度感觉缺失",
        VisualFieldsHint:
          "视野的检测应对照（上部视野和下部视野），通过计数手指或必要时受威胁后眨眼来进行。患者应受到鼓励。若患者能看到移动的手指侧面，则应记录正常。若单眼盲或眼球摘除，则检查另一只眼并记分。仅当明确的非对称盲，包括象限盲时，记 1 分。若为任何原因所致的全盲则记 3 分。若濒临死亡记 1 分，结果用于回答检查项目 11。",
        "1a-LOC_1pt_short": "嗜睡",
        "5-MotorArm_3pt_short": "无法对抗重力",
      },
      form: {
        loc: "",
        locquestion: "",
        loccommand: "",
        gaze: "",
        visual: "",
        facialpalsy: "",
        armleft: "",
        armright: "",
        legleft: "",
        legright: "",
        ataxia: "",
        sensory: "",
        language: "",
        dysarthria: "",
        inattention: "",
      },
      hasScore: false,
      disabled: false,
      // 意识水平
      dataList: [
        { value: "0", name: "清醒；反应灵敏", shortName: "清醒" },
        {
          value: "1",
          name: "嗜睡；轻微刺激能唤醒，可回答问题，执行指令",
          shortName: "嗜睡",
        },
        {
          value: "2",
          name: "昏睡或反应迟钝；需反复刺激、强烈或疼痛刺激才有非刻板的反应",
          shortName: "昏睡",
        },
        {
          value: "3",
          name: "仅有反射性活动或自发性反应或完全无反应、软瘫、以及无反射",
          shortName: "昏迷",
        },
      ],
      // 意识水平提问
      dataList2: [
        { value: "0", name: "两项均正确", shortName: "两项均正确" },
        { value: "1", name: "一项正确", shortName: "一项正确" },
        { value: "2", name: "两项均不正确", shortName: "两项均不正确" },
      ],
      // 意识水平指令
      dataList3: [
        { value: "0", name: "两项均正确", shortName: "两项均正确" },
        { value: "1", name: "一项正确", shortName: "一项正确" },
        { value: "2", name: "两项均不正确", shortName: "两项均不正确" },
      ],
      // 凝视
      dataList4: [
        { value: "0", name: "正常", shortName: "正常" },
        {
          value: "1",
          name: "部分凝视麻痹；单眼或双眼凝视异常，但无强迫凝视或完全凝视麻痹",
          shortName: "部分凝视麻痹",
        },
        {
          value: "2",
          name: "强迫凝视，或完全凝视麻痹，不能被头眼反射克服",
          shortName: "强迫凝视",
        },
      ],
      // 视野
      dataList5: [
        { value: "0", name: "无视野缺损", shortName: "无视野缺损" },
        { value: "1", name: "部分偏盲", shortName: "部分偏盲" },
        { value: "2", name: "完全偏盲", shortName: "完全偏盲" },
        { value: "3", name: "双侧偏盲（包括皮质盲）", shortName: "双侧偏盲" },
      ],
      // 面瘫
      dataList6: [
        { value: "0", name: "正常对称运动", shortName: "正常对称运动" },
        {
          value: "1",
          name: "轻微面瘫（微笑时鼻唇沟变浅、不对称）",
          shortName: "轻微面瘫",
        },
        {
          value: "2",
          name: "部分面瘫（颜面下半部完全或几乎完全瘫痪）",
          shortName: "部分面瘫",
        },
        {
          value: "3",
          name: "完全面瘫（单侧或双侧瘫痪，上下面部缺乏运动）",
          shortName: "完全面瘫",
        },
      ],
      // 上肢运动（左侧）
      dataList7: [
        {
          value: "0",
          name: "无下移；肢体保持抬高 90 度（或 45 度）达 10 秒",
          shortName: "无下移",
        },
        {
          value: "1",
          name: "下移；肢体处于抬高 90 度（或 45 度）位置，但 10 秒内下落；不撞击床或其他支持物",
          shortName: "下移",
        },
        {
          value: "2",
          name: "部分对抗重力；肢体无法达到或维持抬高 90 度（或 45 度），下落到床上，但可以部分对抗重力",
          shortName: "部分对抗重力",
        },
        {
          value: "3",
          name: "无法对抗重力；肢体下落",
          shortName: "无法对抗重力",
        },
        { value: "4", name: "无运动", shortName: "无运动" },
      ],
      // 上肢运动（右侧）
      dataList8: [
        {
          value: "0",
          name: "无下移；肢体保持抬高 90 度（或 45 度）达 10 秒",
          shortName: "无下移",
        },
        {
          value: "1",
          name: "下移；肢体处于抬高 90 度（或 45 度）位置，但 10 秒内下落；不撞击床或其他支持物",
          shortName: "下移",
        },
        {
          value: "2",
          name: "部分对抗重力；肢体无法达到或维持抬高 90 度（或 45 度），下落到床上，但可以部分对抗重力",
          shortName: "部分对抗重力",
        },
        {
          value: "3",
          name: "无法对抗重力；肢体下落",
          shortName: "无法对抗重力",
        },
        { value: "4", name: "无运动", shortName: "无运动" },
      ],
      // 下肢运动（左侧）
      dataList9: [
        {
          value: "0",
          name: "无下移；肢体保持抬高 30 度达 5 秒",
          shortName: "无下移",
        },
        {
          value: "1",
          name: "下移；肢体在 5 秒内下落但不撞击床",
          shortName: "下移",
        },
        {
          value: "2",
          name: "部分对抗重力；肢体在 5 秒内下落到床上，但可以部分对抗重力",
          shortName: "部分对抗重力",
        },
        {
          value: "3",
          name: "无法对抗重力；肢体立即下落到床上",
          shortName: "无法对抗重力",
        },
        { value: "4", name: "无运动", shortName: "无运动" },
      ],
      // 下肢运动（右侧）
      dataList10: [
        {
          value: "0",
          name: "无下移；肢体保持抬高 30 度达 5 秒",
          shortName: "无下移",
        },
        {
          value: "1",
          name: "下移；肢体在 5 秒内下落但不撞击床",
          shortName: "下移",
        },
        {
          value: "2",
          name: "部分对抗重力；肢体在 5 秒内下落到床上，但可以部分对抗重力",
          shortName: "部分对抗重力",
        },
        {
          value: "3",
          name: "无法对抗重力；肢体立即下落到床上",
          shortName: "无法对抗重力",
        },
        { value: "4", name: "无运动", shortName: "无运动" },
      ],
      // 肢体共济失调
      dataList11: [
        { value: "0", name: "无", shortName: "无" },
        { value: "1", name: "表现在一个肢体", shortName: "表现在一个肢体" },
        { value: "2", name: "表现在两个肢体", shortName: "表现在两个肢体" },
      ],
      // 感觉
      dataList12: [
        { value: "0", name: "正常；无感觉缺失", shortName: "正常；无感觉缺失" },
        {
          value: "1",
          name: "轻-中度感觉缺失；患侧感觉针刺不尖锐或迟钝；或针刺感缺失但有触觉",
          shortName: "轻-中度感觉缺失",
        },
        {
          value: "2",
          name: "重度-完全感觉缺失；面部、上肢以及下肢无触觉",
          shortName: "重度-完全感觉缺失",
        },
      ],

      // 语言
      dataList13: [
        { value: "0", name: "无失语；正常", shortName: "无失语；正常" },
        {
          value: "1",
          name: "轻-中度失语；流利程度和理解能力明显下降，但意见表述或表达形式无明显受限。然而，言语和 / 或理解能力的下降可以使得对于指定材料的对话变得困难，甚至难以进行。但是检查者仍可以从患者的反应中判断他想表达的内容。",
          shortName: "轻-中度失语",
        },
        {
          value: "2",
          name: "严重失语；所有交流都是通过破碎的语言表达；听者必须大量依靠推理、询问以及猜测。能够交换的信息很有限；听者感到交流困难。检查者无法从患者的反应中判断他想表达的内容。",
          shortName: "严重失语",
        },
        {
          value: "3",
          name: "缄默，完全性失语；无言语或听力理解能力",
          shortName: "缄默，完全性失语",
        },
      ],
      // 构音障碍
      dataList14: [
        { value: "0", name: "正常", shortName: "正常" },
        {
          value: "1",
          name: "轻-中度构音障碍；轻则个别字词发音不清，重则虽有困难但能被理解",
          shortName: "轻-中度构音障碍",
        },
        {
          value: "2",
          name: "重度构音障碍；患者言语不清，不能被理解，但无失语或与失语不成比例，或失音",
          shortName: "重度构音障碍",
        },
      ],
      // 忽视
      dataList15: [
        { value: "0", name: "正常", shortName: "正常" },
        {
          value: "1",
          name: "视、触、听、空间觉或对人的忽视；或对某一种感觉的双侧刺激忽视",
          shortName: "对一种感觉",
        },
        {
          value: "2",
          name: "严重的偏侧忽视或一种以上的偏侧忽视；不认识自己的手；只能对一侧空间定位",
          shortName: "对一种以上感觉",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),

    maxNSum(num, obj) {
      let self = this;
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // facial + limb + ventilation + resp
        let result =
          form.loc +
          form.locquestion +
          form.loccommand +
          form.gaze +
          form.visual +
          form.facialpalsy +
          form.armleft +
          form.armright +
          form.legleft +
          form.legright +
          form.ataxia +
          form.sensory +
          form.language +
          form.dysarthria +
          form.inattention;
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/NIH.vue